export default {"src":"/_next/static/media/service_unavailable.ec72f8ed.svg","height":219,"width":351,"blurWidth":0,"blurHeight":0};